import * as ActionTypes from '../constants/actions';
import _ from 'lodash';
import moment from 'moment';
import { ChatMessageType } from '../utils/sendbird/messageUtils';

const default_state = {
	messageList : [],
	messageListOld : {},
	chatList: [],
	userAccess: null
};

export default function messages(state = default_state, action) {
	switch (action.type) {
		case ActionTypes.MESSAGES.SET_MESSAGE_LIST: {
			return {
				...state,
				messageListOld : action.messageListOld
			};
		}
		case ActionTypes.MESSAGES.SET_CHAT_LIST: {
			let chatList = _.clone(state.chatList);
			let newChatList = [...chatList, ...action.chatList]

			return {
				...state,
				chatList : newChatList
			};
		}
		case ActionTypes.MESSAGES.APPEND_MESSAGE_LIST: {
			let messageList = _.clone(state.messageList);
			let newMessageList = [...messageList, ...action.messageList]
			return {
				...state,
				messageList : newMessageList
			};
		}
		case ActionTypes.MESSAGES.SET_USER_ACCESS: {
			return {
				...state,
				userAccess: action.userAccess
			};
		}
		default: {
			return state;
		}
	}
}
